
import { WorldCountry } from '../types';

export const greeceData: WorldCountry = {
  code: 'GR',
  name: 'Greece',
  slug: 'greece',
  population: 10700000,
  topCities: [
    // Ciudades principales existentes
    { name: 'Athens', slug: 'athens-greece', population: 3153000 },
    { name: 'Thessaloniki', slug: 'thessaloniki-greece', population: 315000 },
    { name: 'Patras', slug: 'patras-greece', population: 215000 },
    { name: 'Piraeus', slug: 'piraeus-greece', population: 163000 },
    { name: 'Larissa', slug: 'larissa-greece', population: 144000 },
    { name: 'Heraklion', slug: 'heraklion-greece', population: 140000 },
    { name: 'Peristeri', slug: 'peristeri-greece', population: 139000 },
    { name: 'Kallithea', slug: 'kallithea-greece', population: 100000 },
    { name: 'Acharnes', slug: 'acharnes-greece', population: 99000 },
    { name: 'Kalamaria', slug: 'kalamaria-greece', population: 91000 },
    
    // Expansión: 70 ciudades adicionales
    { name: 'Nikaia', slug: 'nikaia-greece', population: 89000 },
    { name: 'Glyfada', slug: 'glyfada-greece', population: 87000 },
    { name: 'Volos', slug: 'volos-greece', population: 86000 },
    { name: 'Ilio', slug: 'ilio-greece', population: 80000 },
    { name: 'Ilioupoli', slug: 'ilioupoli-greece', population: 75000 },
    { name: 'Keratsini', slug: 'keratsini-greece', population: 77000 },
    { name: 'Evosmos', slug: 'evosmos-greece', population: 74000 },
    { name: 'Chalandri', slug: 'chalandri-greece', population: 74000 },
    { name: 'Nea Ionia', slug: 'nea-ionia-greece', population: 67000 },
    { name: 'Marousi', slug: 'marousi-greece', population: 72000 },
    { name: 'Agios Dimitrios', slug: 'agios-dimitrios-greece', population: 71000 },
    { name: 'Zografou', slug: 'zografou-greece', population: 71000 },
    { name: 'Egaleo', slug: 'egaleo-greece', population: 69000 },
    { name: 'Nea Smyrni', slug: 'nea-smyrni-greece', population: 73000 },
    { name: 'Marathonas', slug: 'marathonas-greece', population: 33000 },
    { name: 'Pallini', slug: 'pallini-greece', population: 52000 },
    { name: 'Aigaleo', slug: 'aigaleo-greece', population: 69000 },
    { name: 'Vyronas', slug: 'vyronas-greece', population: 61000 },
    { name: 'Kavala', slug: 'kavala-greece', population: 57000 },
    { name: 'Kalamata', slug: 'kalamata-greece', population: 55000 },
    { name: 'Xanthi', slug: 'xanthi-greece', population: 56000 },
    { name: 'Katerini', slug: 'katerini-greece', population: 56000 },
    { name: 'Trikala', slug: 'trikala-greece', population: 55000 },
    { name: 'Lamia', slug: 'lamia-greece', population: 52000 },
    { name: 'Serres', slug: 'serres-greece', population: 51000 },
    { name: 'Alexandroupoli', slug: 'alexandroupoli-greece', population: 52000 },
    { name: 'Kozani', slug: 'kozani-greece', population: 50000 },
    { name: 'Polichni', slug: 'polichni-greece', population: 36000 },
    { name: 'Chania', slug: 'chania-greece', population: 54000 },
    { name: 'Chalcis', slug: 'chalcis-greece', population: 59000 },
    { name: 'Agia Paraskevi', slug: 'agia-paraskevi-greece', population: 59000 },
    { name: 'Galatsi', slug: 'galatsi-greece', population: 59000 },
    { name: 'Piraeus', slug: 'piraeus-port-greece', population: 51000 },
    { name: 'Rethymno', slug: 'rethymno-greece', population: 32000 },
    { name: 'Ioannina', slug: 'ioannina-greece', population: 65000 },
    { name: 'Komotini', slug: 'komotini-greece', population: 50000 },
    { name: 'Mytilene', slug: 'mytilene-greece', population: 27000 },
    { name: 'Karditsa', slug: 'karditsa-greece', population: 38000 },
    { name: 'Veria', slug: 'veria-greece', population: 45000 },
    { name: 'Corfu', slug: 'corfu-greece', population: 32000 },
    { name: 'Drama', slug: 'drama-greece', population: 44000 },
    { name: 'Giannitsa', slug: 'giannitsa-greece', population: 29000 },
    { name: 'Preveza', slug: 'preveza-greece', population: 19000 },
    { name: 'Tripoli', slug: 'tripoli-greece', population: 47000 },
    { name: 'Livadeia', slug: 'livadeia-greece', population: 21000 },
    { name: 'Argos', slug: 'argos-greece', population: 22000 },
    { name: 'Kilkis', slug: 'kilkis-greece', population: 17000 },
    { name: 'Florina', slug: 'florina-greece', population: 17000 },
    { name: 'Kastoria', slug: 'kastoria-greece', population: 16000 },
    { name: 'Grevena', slug: 'grevena-greece', population: 13000 },
    { name: 'Edessa', slug: 'edessa-greece', population: 19000 },
    { name: 'Naoussa', slug: 'naoussa-greece', population: 19000 },
    { name: 'Ptolemaida', slug: 'ptolemaida-greece', population: 32000 },
    { name: 'Naousa', slug: 'naousa-greece', population: 22000 },
    { name: 'Polygyros', slug: 'polygyros-greece', population: 10000 },
    { name: 'Nea Moudania', slug: 'nea-moudania-greece', population: 18000 },
    { name: 'Arnaia', slug: 'arnaia-greece', population: 2500 },
    { name: 'Kassandra', slug: 'kassandra-greece', population: 16000 },
    { name: 'Sithonia', slug: 'sithonia-greece', population: 12000 },
    { name: 'Ouranoupoli', slug: 'ouranoupoli-greece', population: 1000 },
    { name: 'Ierissos', slug: 'ierissos-greece', population: 3000 },
    { name: 'Stagira', slug: 'stagira-greece', population: 2500 },
    { name: 'Stratoni', slug: 'stratoni-greece', population: 1000 },
    { name: 'Olympiada', slug: 'olympiada-greece', population: 600 },
    { name: 'Vavdos', slug: 'vavdos-greece', population: 400 },
    { name: 'Megali Panagia', slug: 'megali-panagia-greece', population: 1500 },
    { name: 'Gomati', slug: 'gomati-greece', population: 800 },
    { name: 'Paleochora', slug: 'paleochora-greece', population: 2200 },
    { name: 'Agios Nikolaos', slug: 'agios-nikolaos-greece', population: 11000 },
    { name: 'Sitia', slug: 'sitia-greece', population: 9000 },
    { name: 'Ierapetra', slug: 'ierapetra-greece', population: 12000 },
    { name: 'Malia', slug: 'malia-greece', population: 3000 },
    { name: 'Hersonissos', slug: 'hersonissos-greece', population: 26000 },
    { name: 'Elounda', slug: 'elounda-greece', population: 2000 },
    { name: 'Kissamos', slug: 'kissamos-greece', population: 5000 },
    { name: 'Platanias', slug: 'platanias-greece', population: 4500 }
  ]
};
